'use client'

import {
  IntlProvider,
  load,
  loadMessages,
  LocalizationProvider,
} from '@progress/kendo-react-intl'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import coCaGregorian from 'cldr-dates-full/main/es-CO/ca-gregorian.json'
import coDateFields from 'cldr-dates-full/main/es-CO/dateFields.json'
import ecCaGregorian from 'cldr-dates-full/main/es-EC/ca-gregorian.json'
import ecDateFields from 'cldr-dates-full/main/es-EC/dateFields.json'
import peCaGregorian from 'cldr-dates-full/main/es-PE/ca-gregorian.json'
import peDateFields from 'cldr-dates-full/main/es-PE/dateFields.json'
import coLocalCurrency from 'cldr-numbers-full/main/es-CO/currencies.json'
import coNumbers from 'cldr-numbers-full/main/es-CO/numbers.json'
import ecLocalCurrency from 'cldr-numbers-full/main/es-EC/currencies.json'
import ecNumbers from 'cldr-numbers-full/main/es-EC/numbers.json'
import peLocalCurrency from 'cldr-numbers-full/main/es-PE/currencies.json'
import peNumbers from 'cldr-numbers-full/main/es-PE/numbers.json'
import { ReactNode } from 'react'

import esMessages from '../../../translations/es/global.json'
import esMessagesSchedule from '../../globalization/schedule/es.json'

import { getCurrencyConfig } from '@/core/config/moneda.config'

// Los mismos tres locales que declara regionConfig en moneda.config. Un solo bundle sirve a
// Ecuador y Perú, así que los datos de todos se cargan de entrada: cuál se usa se decide recién
// al renderizar, con la región de runtime.
const LOCALES_SOPORTADOS = ['es-EC', 'es-PE', 'es-CO']

// Los mensajes son los mismos en los tres países, pero Kendo los busca por locale: hay que
// registrarlos bajo cada uno o la interfaz saldría sin traducir en la región que no esté dada de alta.
LOCALES_SOPORTADOS.forEach((locale) => {
  loadMessages({ ...esMessages, ...esMessagesSchedule }, locale)
})

load(
  likelySubtags,
  currencyData,
  weekData,
  ecNumbers,
  ecLocalCurrency,
  ecCaGregorian,
  ecDateFields,
  peNumbers,
  peLocalCurrency,
  peCaGregorian,
  peDateFields,
  coNumbers,
  coLocalCurrency,
  coCaGregorian,
  coDateFields,
)

interface IConfigLanguageContainerProps {
  children: ReactNode
}

const ConfigLanguageContainer: React.FC<IConfigLanguageContainerProps> = ({
  children,
}) => {
  // Este contenedor va dentro de ConfigRuntimeProvider, que muestra un loader hasta hidratar la
  // configuración, así que acá la región ya es la real y no el valor por defecto.
  const { locale } = getCurrencyConfig()

  return (
    <LocalizationProvider language={locale}>
      <IntlProvider locale={locale}>{children}</IntlProvider>
    </LocalizationProvider>
  )
}

export default ConfigLanguageContainer
